// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2CQcz","box":"WorkspacesBox_box__2mQHh","node":"WorkspacesBox_node__1WpIT"};